module.exports = __webpack_public_path__ + "img/home-province.deb484f2.png";